import * as yup from "yup";

const phoneNumberRegex = /\s*(([+](\s?\d)([-\s]?\d)|0)?(\s?\d)([-\s]?\d){9}|[(](\s?\d)([-\s]?\d)+\s*[)]([-\s]?\d)+)\s*/;

export const EmergencyContactValidationSchema = yup.object().shape({
  firstName: yup.string().trim().required("Enter their first name"),
  lastName: yup.string().trim().required("Enter their last name"),
  phoneNumber: yup
    .string()
    .matches(phoneNumberRegex, "Enter a valid phone number")
    .required("Enter their phone number"),
});

export const LongTermHealthConditionsValidationSchema = yup.object().shape({
  longTermHealthConditions: yup.string().required("Select an option"),
});

export const AllergiesValidationSchema = yup.object().shape({
  allergies: yup.string().required("Please specify any allergies").max(1000, "Tell us in 1000 characters or less"),
});
export const AnyAllergiesValidationSchema = yup.object().shape({
  anyAllergies: yup.string().required("Select an option"),
});
export const AnyMedicationValidationSchema = yup.object().shape({
  anyMedication: yup.string().required("Select an option"),
});
export const MedicationsValidationSchema = yup.object().shape({
  medication: yup.string().required("Please specify any medication").max(1000, "Tell us in 1000 characters or less"),
});

export const HealthConditionsValidationSchema = yup.object().shape({
  healthConditions: yup.array().nullable().of(yup.string()).min(1, "Please select at least one option").required("Please select at least one option"),
  otherHealthConditions: yup.mixed().when("healthConditions", {
    is: (value: string[] | undefined) => value?.includes("other"),
    then: yup.string().nullable().required("Please specify any health conditions").max(1000, "Tell us in 1000 characters or less"),
    otherwise: yup.string().nullable().notRequired(),
  }),
});

export const EthnicityValidationSchema = yup.object().shape({
  ethnicity: yup.object().nullable().required("Please select an option"),
});

export const DateOfBirthValidationSchema = yup.object().shape({
  date: yup.string(),
  month: yup.string(),
  year: yup.string(),
});
